import makeCreators from '@main/factories/pages/makeCreators';
import { useData } from 'vike-react/useData';

import type { Data } from '../category/@contentIdWithNiceName/+data';

export function Page() {
	const { firstPage } = useData<Data>();

	return makeCreators(firstPage);
}
